import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const ContentText = styled.div`
  margin-right: 10px;
  word-break: break-word;

  h4 {
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
  }

  p {
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #606060;
  }
`

export const ImageContainer = styled.div`
  align-self: center;

  img {
    height: 250px;
    width: 500px;
  }

  @media ${queries.less.sm} {
    img {
      height: 200px;
    }
  }
`
